import audioSttMicrophone from '@/assets/Audio/STT/Microphone.svg'
import audioTtsSpeaker from '@/assets/Audio/TTS/Speaker.svg'
import dictionaryNoResults from '@/assets/Dictionary/no_results.svg'
import dictionaryNoResultsFolder from '@/assets/Dictionary/no_results_folder.svg'
import documentEditorDragHandle from '@/assets/DocumentEditor/drag-handle.svg'
import documentEditorEdit from '@/assets/DocumentEditor/edit.svg'
import documentEditorAiRewrite from '@/assets/DocumentEditor/ai_rewrite.svg'
import documentEditorTmAddHeader from '@/assets/DocumentEditor/tm_add_header.svg'
import documentTranslateTranslator from '@/assets/DocumentTranslate/DocumentTranslator.svg'
import documentsViewerAlert from '@/assets/DocumentsViewer/Alert.svg'
import documentsViewerMagnifyingGlass from '@/assets/DocumentsViewer/MagnifyingGlass.svg'
import documentsViewerDeleteInput from '@/assets/DocumentsViewer/deleteInput.svg'
import documentsViewerDeleteMore from '@/assets/DocumentsViewer/deleteMore.svg'
import documentsViewerDownloadMore from '@/assets/DocumentsViewer/downloadMore.svg'
import documentsViewerEdit from '@/assets/DocumentsViewer/edit.svg'
import documentsViewerInfo from '@/assets/DocumentsViewer/info.svg'
import documentsViewerMore from '@/assets/DocumentsViewer/more.svg'
import documentsViewerArrow from '@/assets/DocumentsViewer/Arrow.svg'
import glossaryMore from '@/assets/Glossary/More.svg'
import glossaryDump from '@/assets/Glossary/dump.svg'
import glossaryRename from '@/assets/Glossary/rename.svg'
import glossaryExport from '@/assets/Glossary/export.svg'
import glossaryImport from '@/assets/Glossary/import.svg'
import glossaryAddToGlossary from '@/assets/Glossary/add_to_glossary.svg'
import languageCorrectionBack from '@/assets/LanguageCorrection/back.svg'
import languageCorrectionForward from '@/assets/LanguageCorrection/forward.svg'
import mainPageDictionary from '@/assets/MainPage/Dictionary.svg'
import memoryFilter from '@/assets/Memory/filter.svg'
import memoryUploadDocument from '@/assets/Memory/upload_document.svg'
import memoryUploadedDocument from '@/assets/Memory/uploaded_document.svg'
import textTranslateClose from '@/assets/TextTranslate/Close.svg'
import textTranslateCopy from '@/assets/TextTranslate/Copy.svg'
import textTranslateEllipsis from '@/assets/TextTranslate/Ellipsis.svg'
import textTranslateKeyboard from '@/assets/TextTranslate/keyboard.svg'
import topBarUser from '@/assets/TopBar/user.svg'
import topBarIconLanguage from '@/assets/TopBar/icon_language.svg'
import topBarLogout from '@/assets/TopBar/logout.svg'
import userPanelsEdit from '@/assets/UserPanels/Edit.svg'
import documentTranslator from '@/assets/Sidebar/document_translator.svg'
import textTranslation from '@/assets/Sidebar/text_translation.svg'
import textPolisher from '@/assets/Sidebar/text_polisher.svg'
import documents from '@/assets/Sidebar/documents.svg'
import glossary from '@/assets/Sidebar/glossary.svg'
import translationMemory from '@/assets/Sidebar/translation_memory.svg'
import global from '@/assets/TranslationSettings/gps.svg'
import pencilLine from '@/assets/TranslationSettings/edit.svg'

export const customIcons = {
  'audio/stt/microphone': audioSttMicrophone,
  'audio/tts/speaker': audioTtsSpeaker,
  'dictionary/no-results': dictionaryNoResults,
  'dictionary/no-results-folder': dictionaryNoResultsFolder,
  'document-editor/drag-handle': documentEditorDragHandle,
  'document-editor/edit': documentEditorEdit,
  'document-editor/ai-rewrite': documentEditorAiRewrite,
  'document-editor/tm-add-header': documentEditorTmAddHeader,
  'document-translate/document-translator': documentTranslateTranslator,
  'documents-viewer/alert': documentsViewerAlert,
  'documents-viewer/magnifying-glass': documentsViewerMagnifyingGlass,
  'documents-viewer/delete-input': documentsViewerDeleteInput,
  'documents-viewer/delete-more': documentsViewerDeleteMore,
  'documents-viewer/download-more': documentsViewerDownloadMore,
  'documents-viewer/edit': documentsViewerEdit,
  'documents-viewer/info': documentsViewerInfo,
  'documents-viewer/more': documentsViewerMore,
  'documents-viewer/arrow': documentsViewerArrow,
  'glossary/more': glossaryMore,
  'glossary/dump': glossaryDump,
  'glossary/rename': glossaryRename,
  'glossary/export': glossaryExport,
  'glossary/import': glossaryImport,
  'glossary/add-to-glossary': glossaryAddToGlossary,
  'language-correction/back': languageCorrectionBack,
  'language-correction/forward': languageCorrectionForward,
  'main-page/dictionary': mainPageDictionary,
  'main-page/documents': documents,
  'main-page/glossary': glossary,
  'main-page/text-polisher': textPolisher,
  'main-page/text-translator': textTranslation,
  'memory/filter': memoryFilter,
  'memory/upload-document': memoryUploadDocument,
  'memory/uploaded-document': memoryUploadedDocument,
  'text-translate/close': textTranslateClose,
  'text-translate/copy': textTranslateCopy,
  'text-translate/ellipsis': textTranslateEllipsis,
  'text-translate/keyboard': textTranslateKeyboard,
  'topbar/user': topBarUser,
  'topbar/icon-language': topBarIconLanguage,
  'topbar/logout': topBarLogout,
  'user-panels/edit': userPanelsEdit,
  'sidebar/document-translator': documentTranslator,
  'sidebar/text-translation': textTranslation,
  'sidebar/text-polisher': textPolisher,
  'sidebar/documents': documents,
  'sidebar/glossary': glossary,
  'sidebar/translation-memory': translationMemory,
  'translation-settings/global': global,
  'translation-settings/edit': pencilLine,
}
